import React, { useEffect, useState } from "react";
import { DataTable } from "./DataTable";
import { Button, Modal, Select } from "antd";
import { YhBox } from "@/components/YhBox";
import { useWlocModel } from "../wlocModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { IWarningTimeDs } from '@/types/FmsDs';
import useGlobalModel from '@/model/globalModel';
import { wcdService } from '../../customsDeclaration/wcdService';
import { ISelectOption } from '@/components/YhFormBox/Types';
import { globalPrompt } from '@/components/message';
const { Option } = Select;
export const DataBox = () => {
    const { user: { shopCode, shopName } } = useGlobalModel()
    const { exportWloc, loadData } = useWlocModel();
    // 交单日期
    let presentationTime: string
    const [presentationWarning, setPresentationWarning] = useState('')
    // 到证日期
    let arrivalTime: string
    const [arrivalWarning, setArrivalWarning] = useState('')
    // 最迟船期
    let scheduleTime: string
    const [scheduleWarning, setScheduleWarning] = useState('')

    const onPresentationChange = (value: string, option: ISelectOption) => {
        presentationTime = value
    }
    const onArrivalChange = (value: string, option: ISelectOption) => {
        arrivalTime = value
    }
    const onScheduleChange = (value: string, option: ISelectOption) => {
        scheduleTime = value
    }

    // 获取预警设置
    const getWarningTime = async () => {
        let { retData } = await wcdService.allList()
        if (retData.length > 0) {
            let filterPre = retData.filter(item => item.warningType === 'warning.presentation')
            let filterArr = retData.filter(item => item.warningType === 'warning.arrival')
            let filterSch = retData.filter(item => item.warningType === 'warning.schedule')
            setPresentationWarning(filterPre[0]?.warningTime ?? '')
            setArrivalWarning(filterArr[0]?.warningTime ?? '')
            setScheduleWarning(filterSch[0]?.warningTime ?? '')
        } else {
            let warningTime = ''
            setPresentationWarning(warningTime)
            setArrivalWarning(warningTime)
            setScheduleWarning(warningTime)
        }
    }

    // 预警设置
    const onSave = async () => {
        const data = [
            {
                shopCode,
                shopName,
                warningTime: presentationTime,
                warningType: 'warning.presentation'
            }, {
                shopCode,
                shopName,
                warningTime: arrivalTime,
                warningType: "warning.arrival"
            }, {
                shopCode,
                shopName,
                warningTime: presentationTime,
                warningType: 'warning.schedule'
            },

        ]
        let { retData } = await wcdService.warning(data)
        if (retData) {
            loadData()
            getWarningTime()
            globalPrompt("message", { text: "预警设置成功", type: "success" })
        } else {
            globalPrompt("message", { text: "预警设置失败", type: "error" })
        }
    }

    useEffect(() => {
        getWarningTime()
    }, [])

    const onSet = () => {
        Modal.confirm({
            width: 500,
            title: '预警设置',
            content: (
                <>
                    <div>交单日期提前<span style={{ marginLeft: 10, marginRight: 10 }}>
                        <Select
                            defaultValue={presentationWarning ?? ''}
                            style={{ width: 200 }}
                            options={IWarningTimeDs}
                            onChange={(value: string, options: any) => onPresentationChange(value, options as ISelectOption)}
                        >
                        </Select>
                    </span>开启预警？</div>
                    <div style={{ marginTop: 10, marginBottom: 10 }}>到证日期提前<span style={{ marginLeft: 10, marginRight: 10 }}>
                        <Select
                            defaultValue={arrivalWarning ?? ''}
                            style={{ width: 200 }}
                            options={IWarningTimeDs}
                            onChange={(value: string, options: any) => onArrivalChange(value, options as ISelectOption)}
                        >
                        </Select>
                    </span>开启预警？</div>
                    <div>最迟船期提前<span style={{ marginLeft: 10, marginRight: 10 }}>
                        <Select
                            defaultValue={scheduleWarning ?? ''}
                            style={{ width: 200 }}
                            options={IWarningTimeDs}
                            onChange={(value: string, options: any) => onScheduleChange(value, options as ISelectOption)}
                        >
                        </Select>
                    </span>开启预警？</div>
                </>
            ),
            centered: true,
            okText: "确定",
            onOk: () => { onSave() },
            cancelText: "取消",
            onCancel: () => { },
        })
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportWloc()}
        >导出</Button>
        <YhAuth resCode={ResourceAuthEnum.W_L_WARN}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onSet}
            >预警设置</Button>
        </YhAuth>

    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}